import { useEffect } from 'react';
import { CheckCircle, X } from 'lucide-react';

const SuccessPopup = ({ message = 'Успешно отправлено!', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-5 right-5 z-50 bg-white border border-green-200 shadow-xl rounded-lg px-4 py-3 flex items-center space-x-3 animate-slide-in-down">
      <div className="flex-1 text-sm text-gray-800 font-medium">{message}</div>
      <CheckCircle className="text-green-600 w-4 h-4 mt-0.5" />
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-gray-600"
        aria-label="Закрыть"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SuccessPopup;
